// extracted by mini-css-extract-plugin
export default {"table":"DataTableRemotePaging_table__6tEMN","pageSize":"DataTableRemotePaging_pageSize__GJKAP","selected":"DataTableRemotePaging_selected__FfFCf"};